import api from "../../../api";

// show share classes if there is more than 1 share class
export const hasMultipleShareClasses = (shareClasses?: api.ShareClass[]) =>
  Boolean(shareClasses && shareClasses.length > 1);
